import { render, staticRenderFns } from "./PaginaConfiguracionBoletas.vue?vue&type=template&id=2df89cb7"
import script from "./PaginaConfiguracionBoletas.vue?vue&type=script&lang=js"
export * from "./PaginaConfiguracionBoletas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports